import React from 'react';
import { tr } from '../../i18n';
import { SystemStateAction } from './EmptyState';
import './system-states.css';

type ErrorStateProps = {
  title?: string;
  description?: string;
  traceId?: string;
  actions?: SystemStateAction[];
};

const ErrorState: React.FC<ErrorStateProps> = ({
  title = tr.shell.systemStates.errorTitle,
  description,
  traceId,
  actions
}) => (
  <div className="sys-state">
    <div className="sys-state-icon-wrap sys-state-icon-wrap--danger">⚠</div>
    <h3 className="sys-state-title">{title}</h3>
    {description && <p className="sys-state-desc">{description}</p>}
    {traceId && <span className="sys-state-trace">trace_id: {traceId}</span>}
    {actions && actions.length > 0 && (
      <div className="sys-state-actions">
        {actions.map((a, i) => {
          const cls = `sys-state-btn sys-state-btn--${a.variant ?? 'outline'}`;
          return a.href
            ? <a key={i} href={a.href} className={cls}>{a.label}</a>
            : <button key={i} type="button" className={cls} onClick={a.onClick}>{a.label}</button>;
        })}
      </div>
    )}
  </div>
);

export default ErrorState;
